/**
 * API service for reference state and reference events
 */

import { Badges, EventsQuery, ReferenceEvent, References } from '../types/references';
import httpClient from './httpClient';

const api = httpClient;

const eventParams = ({ limit, before, minSeverity }: EventsQuery) => ({
  ...(limit !== undefined ? { limit } : {}),
  ...(before !== undefined ? { before } : {}),
  ...(minSeverity !== undefined ? { min_severity: minSeverity } : {}),
});

export const referencesApi = {
  async getReferences(deviceId: number): Promise<References> {
    const response = await api.get<References>(`/devices/${deviceId}/references`);
    return response.data;
  },

  async getBadges(): Promise<Badges> {
    const response = await api.get<Badges>('/devices/references/badges');
    return response.data;
  },

  async getDeviceEvents(deviceId: number, query: EventsQuery = {}): Promise<ReferenceEvent[]> {
    const response = await api.get<ReferenceEvent[]>(`/devices/${deviceId}/events`, { params: eventParams(query) });
    return response.data;
  },

  async getEvents(query: EventsQuery = {}): Promise<ReferenceEvent[]> {
    const response = await api.get<ReferenceEvent[]>('/events', { params: eventParams(query) });
    return response.data;
  },
};

export default referencesApi;
